export default __webpack_public_path__ + "static/media/partner-aradena.7007d588.png";